const backToTopButton = document.querySelector('.app-back-to-top')

if (backToTopButton) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
      backToTopButton.classList.add('is-visible')
    } else {
      backToTopButton.classList.remove('is-visible')
    }
  })

  backToTopButton.addEventListener('click', () => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  })
}